import { Checkbox } from "@/modules/shadcn/ui/checkbox";
import { type CellContext, type HeaderContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

// Header/cell renderers for the column helpers. flexRender mounts a function
// template as a component, so these may use hooks.

export function SelectAllCheckbox<T>({ table }: HeaderContext<T, unknown>) {
  const { t } = useTranslation("common");
  return (
    <Checkbox
      checked={table.getIsAllPageRowsSelected()}
      indeterminate={table.getIsSomePageRowsSelected()}
      onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      aria-label={t("table.selectAll")}
    />
  );
}

export function SelectRowCheckbox<T>({ row }: CellContext<T, unknown>) {
  const { t } = useTranslation("common");
  return (
    <Checkbox
      checked={row.getIsSelected()}
      onCheckedChange={(value) => row.toggleSelected(!!value)}
      aria-label={t("table.selectRow")}
    />
  );
}

export function ActionsHeader() {
  const { t } = useTranslation("common");
  return t("table.action");
}
